import { Button } from '@wartek-id/button-v1'
import { Icon } from '@wartek-id/icon-v2'

const MessageOptions = ({ onClick }) => {
  return (
    <div className="flex justify-end">
      <Button
        data-testid="conversation-message-options"
        className="cursor-pointer hover:!cursor-pointer"
        aria-label="Opsi"
        variant="ghost"
        iconOnly
        onClick={onClick}
      >
        <Icon className="!text-subdued">more_vert</Icon>
      </Button>
    </div>
  )
}

export default MessageOptions
